export default "__VITE_ASSET__CjbPkptJ__"